import * as React from 'react';
import classnames from 'classnames';
import { CLQuantitySelectorContainer } from '../CLQuantitySelector/CLQuantitySelectorContainer.js';
import { CLStockIndicator } from '../CLStockIndicator/CLStockIndicator.js';

const NoRxSelectionColumn = /*#__PURE__*/ React.memo(({ eyeSideId , className , 'data-t': dataT  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('no-rx-selection-column', className),
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement(CLQuantitySelectorContainer, {
        eyeSideId: eyeSideId,
        className: "no-rx-selection-column__quantity-select",
        isEnabled: true
    }), /*#__PURE__*/ React.createElement(CLStockIndicator, {
        eyeSideId: eyeSideId,
        className: "no-rx-selection-column__stock"
    }));
});

export { NoRxSelectionColumn };
//# sourceMappingURL=NoRxSelectionColumn.js.map
